import { Component, OnInit, Injector, ViewChild, Injectable, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { DataService } from 'src/app/Common/data.service';
import { CommonService } from 'src/app/shared/common.service';
import { Global } from 'src/app/Global';

import * as XLSX from 'xlsx';
import saveAs from 'file-saver';
//import { isNumber } from 'util';

@Component({
  selector: 'app-escalation-sequence',
  templateUrl: './escalation-sequence.component.html',
  styleUrls: ['./escalation-sequence.component.scss'],
  providers: [DataService]
})
export class EscalationSequenceComponent implements OnInit {
  EscalationForm: UntypedFormGroup;
  requesterList: any;
  groupList: any;
  empList: any;
  EscalationList: any;
  filterList: any;
  displayedColumns = ['#', 'Category', 'SubCategory', 'ItemName', 'GroupName'];
  displayedColumns1 = ['GroupName', 'EscalationSequence', 'Hour', 'EmpGPN', 'EmployeeName', 'Status', 'Update'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  viewdata: any;
  EscalationDataSource: any[];
  EscalationListDataSource: any[];
  @ViewChild('TABLE') table: ElementRef;
  Ispanelshow: any;
  IsAddpanelshow: any;

  constructor(public _global: Global, public _dataservice: DataService, private _fb: UntypedFormBuilder, public _commonService: CommonService, private status: HTTPStatus, private error: AppErrorHandler) { }

  ngOnInit() {
    //this.paginator.showFirstLastButtons = true;
    this.Ispanelshow = false;
    this.IsAddpanelshow = false;
    //this.paginator.pageSize = this._global.RecordSize;
    this.EscalationForm = this._fb.group({
      Id: [''],
      GroupId: [''],
      KeywordValue: [''],
      SelectedGroup: [[], Validators.required],
      SelectedEscalation: [[], Validators.required],
      EmpName: [[], Validators.required],
      Hour: ['', Validators.required],
      spmode: [''],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      Employee: [''],
      GroupSearch: [''],
      EmpGPN: [''],
    });
    this.BindGroupList();
    this.BindEscalationList();
    this.SearchRecord();
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = this._global.RecordSize;
      this.paginator.showFirstLastButtons = true;
    }
  }

  SearchRecord() {
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this._global.RecordSize = 10;
    this.ViewEscalationData();
  }

  BindGroupList() {
    this._dataservice.GetData('Category/GetGroup/').subscribe(result => {
      this.groupList = result;
    });
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.EscalationForm.controls).forEach(field => {
      const control = this.EscalationForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  GetFormControls(controlName) {
    return this.EscalationForm.controls[controlName];
  }


  Adddata() {
    this.GetFormControls('SelectedGroup').setValidators([Validators.required]);
    this.GetFormControls('SelectedGroup').updateValueAndValidity();
    this.GetFormControls('SelectedEscalation').setValidators([Validators.required]);
    this.GetFormControls('SelectedEscalation').updateValueAndValidity();
    this.GetFormControls('Hour').setValidators([Validators.required]);
    this.GetFormControls('Hour').updateValueAndValidity();
    this.GetFormControls('EmpName').setValidators([Validators.required]);
    this.GetFormControls('EmpName').updateValueAndValidity();

    if (!this.EscalationForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();

      return false;
    }
    var hour1 = Number(this.EscalationForm.controls.Hour.value);
    var hour2 = this.EscalationForm.controls.Hour.value;
    if (hour1 == hour2) {
    }
    else {
      alert('Please fill valid hour');
      return false;
    }
    if (this.EscalationForm.controls.Hour.value < 1) {
      alert('Please fill minimum 1 hour');
      return false;
    }
    this.EscalationForm.patchValue({
      GroupId: this.EscalationForm.controls.SelectedGroup.value.GroupId,
      KeywordValue: this.EscalationForm.controls.SelectedEscalation.value.KeywordValue,
    });
    this.status.setHttpStatus(true);
    this._dataservice.PostData('Category/AddEscalationData/', this.EscalationForm.value).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.ClearData();
        this.Displaygroupdetail();
        this.ViewEscalationData();
        this.GetFormControls('SelectedGroup').clearValidators();
        this.GetFormControls('SelectedGroup').updateValueAndValidity();
        this.GetFormControls('SelectedEscalation').clearValidators();
        this.GetFormControls('SelectedEscalation').updateValueAndValidity();
        this.GetFormControls('Hour').clearValidators();
        this.GetFormControls('Hour').updateValueAndValidity();
        this.GetFormControls('EmpName').clearValidators();
        this.GetFormControls('EmpName').updateValueAndValidity();
      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => {
        this.status.setHttpStatus(false);
      });
  }

  statusupdatedata(element) {
    // this.AssigmentDataSource.data.splice(element,1);
    //   this.AssigmentDataSource = new MatTableDataSource<any>(this.AssigmentDataSource.data);

    if (confirm('Are you sure to want update status this record?')) {
      this.EscalationForm.patchValue({
        // Assigment:this.AssigmentForm.controls.Assigment.value.data,
        GroupId: 0,
        KeywordValue: 0,
        Id: element,
      });
      this.status.setHttpStatus(true);
      this._dataservice.PostData('Category/AddEscalationData/', this.EscalationForm.value).subscribe(result => {
        alert(result[0].MSG);
        if (result[0].STATUS == 0) {
          this.ClearData();
          this.ViewEscalationData();
        }

      }
        , (error) => {
          this.status.setHttpStatus(false);
          this.error.handleError(error);
        },
        () => { this.status.setHttpStatus(false); });
    }
  }


  ClearData() {
    this.EscalationForm.controls.SelectedGroup.setValue('');
    this.EscalationForm.controls.SelectedEscalation.setValue('');
    this.EscalationForm.controls.Hour.setValue('');
    var objProcList1 = [];
    this.EscalationForm.controls.EmpName.setValue(objProcList1);
    this.EscalationForm.patchValue({
      Id: 0
    });
  }

  rowclickdata(row: any) {
    var dataitem;
    dataitem = this.EscalationListDataSource.filter(x => x.Id == row);
    this.EscalationForm.patchValue({
      Id: row,
      SelectedGroup: this.BindSpecialization(dataitem[0]['GroupName']),
      SelectedEscalation: this.BindSpecialization1(dataitem[0]['KeywordName']),
      Hour: dataitem[0]['TimePeriod'],
    });
    this.Displaygroupdetail();
    // this.requesterList = {
    //   EmployeeGPN: dataitem[0]['EmpGPN'], EmpName:  dataitem[0]['EmpName']+ '(' + dataitem[0]['EmpEmail'] + ')'};
    // this.EscalationForm.controls.EmpName.setValue(this.requesterList);
    var objProcList = [];
    if (dataitem != null) {
      let _specialization2: Array<number> = dataitem[0]['EmpEmail'].split(",");
      let _specialization3: Array<number> = dataitem[0]['EmpGPN'].split(",");
      let _specialization: Array<number> = dataitem[0]['EmpName'].split(",");
      for (var i = 0; i < _specialization.length; i++) {
        objProcList.push({
          EmpName: _specialization[i] + '(' + _specialization2[i] + ')',
          EmployeeGPN: _specialization3[i]
        });
      }
    }
    this.EscalationForm.controls.EmpName.setValue(objProcList);
  }

  BindSpecialization(sf) {
    let p = this.groupList.filter(x => x.GroupName == sf);
    return p[0];
  }
  BindSpecialization1(sf) {
    let p = this.EscalationList.filter(x => x.KeywordName == sf);
    return p[0];
  }

  Relod() {
    window.location.reload();
  }

  Displaygroupdetail() {
    this.EscalationForm.patchValue({
      GroupId: this.EscalationForm.controls.SelectedGroup.value.GroupId,
    });
    this._dataservice.PostData('Category/GetEscalationGroupDetail/', this.EscalationForm.value).subscribe(result => {
      this.viewdata = result;
      this.EscalationDataSource = this.viewdata;
    });
  }

  SearchActiveEmployee = (event) => {
    this._commonService.Autocomplete('FillCommonData/GetActiveEmployee', event.query).subscribe(result => {
      this.requesterList = this.filterDataList(event.query, result);

    }, (error) => {
      this.error.handleError(error);
    }, () => {
    });
  }
  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }

  SetEmployeeDetails(event) {
  }

  clearAutoComplete(controlName) {
  }

  UnselectEmpName() {
  }

  BindEscalationList() {
    this.EscalationForm.patchValue({
      spmode: 1,
    });
    this._dataservice.PostData('Category/GetEscalationList/', this.EscalationForm.value).subscribe(result => {
      this.EscalationList = result;
    });
  }

  ViewEscalationData() {
    this.EscalationForm.controls.PageNumber.setValue(this._global.pageIndex + 1);
    // if(this.EscalationForm.controls.EmpName.value.length==0){
    //   this.EscalationForm.controls.EmpName.setValue("");

    //   }
    this.EscalationForm.controls.PageSize.setValue(this._global.RecordSize);
    this.EscalationForm.patchValue({
      GroupId: this.EscalationForm.controls.GroupSearch.value.GroupId,
      EmpGPN: this.EscalationForm.controls.Employee.value.EmployeeGPN,
    });
    this._dataservice.PostData('Category/GetEscalationViewList/', this.EscalationForm.value).subscribe(result => {
      this.viewdata = result;
      // this.EscalationListDataSource = this.viewdata;

      if (this.viewdata != null && this.viewdata.length > 0) {
        this.EscalationListDataSource = this.viewdata;
        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);

      } else {
        this.EscalationListDataSource = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    });
  }


  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.ViewEscalationData();
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Escalation_sequence.xlsx');

  }

  Export() {
    this.status.setHttpStatus(true);
    this._commonService.ExportToExcelEscalation(this.EscalationForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'Escalation_sequence.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  clearAutoCompleteSearch(ControlName) {
    if (ControlName == 'Employee') {
      this.EscalationForm.controls.Employee.reset();
    }
    else if (ControlName == 'GroupSearch') {
      this.EscalationForm.controls.GroupSearch.reset();
    }
  }


  ResetData() {

    this.EscalationForm.reset({
      "Employee": "",
      "GroupSearch": ""
    })
    this.GetResult();

  }

  Exit() {

    if (this.EscalationForm.valid) {
      if (confirm("Are you sure you want to exit without saving changes?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    } else {
      if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    }

  }

  GetResult() {

    this.SearchRecord();
  }

  showhide() {
    this.Ispanelshow = !this.Ispanelshow;

  }

  showhideAdd() {
    this.IsAddpanelshow = !this.IsAddpanelshow;

  }


}


